import { render, staticRenderFns } from "./RechargeBalance.vue?vue&type=template&id=13367c98&scoped=true&"
import script from "./RechargeBalance.vue?vue&type=script&lang=js&"
export * from "./RechargeBalance.vue?vue&type=script&lang=js&"
import style0 from "./RechargeBalance.vue?vue&type=style&index=0&id=13367c98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13367c98",
  null
  
)

export default component.exports